import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const RLCSinglePhaseThreePhase = () => (
  <QPhototModuleSubtopic
    title="Single Phase RLC series circuit and Three Phase"
    videos={[
      "https://www.youtube.com/embed/ERIToctYUcQ",
      "https://www.youtube.com/embed/az_SeEoZ8zI",
      "https://www.youtube.com/embed/01hhrkDa6ZE",
      "https://www.youtube.com/embed/Bw16MmjiRR4",
      "https://www.youtube.com/embed/MvSkXYUyMys",
      "https://www.youtube.com/embed/pTkNXgGXCjo"
    ]}
    takeaways={[
      { text: "Practice as many as possible problems." },
      { text: "This module is simple and try not to confuse for Rms and peak values." },
      { text: "Three phasors question is always asked in CAT-2 and FAT." }
    ]}
    questions={[
      { image: "/beee_15.jpeg" },
      { image: "/beee_16.jpeg" },
      { image: "/beee_17.jpeg" },
      { image: "/beee_18.jpeg" },
      { image: "/beee_19.jpeg" },
      { image: "/beee_20.jpeg" },
      { image: "/beee_21.jpeg" },
      { image: "/beee_22.jpeg" }
    ]}
    exampleVideos={[]}
  />
);

export default RLCSinglePhaseThreePhase;
